import { ComponentType } from 'react';

import { BoxProps } from 'components/ui';
import { IMarketingCardGroupFragment, IMarketingTileGroup } from 'generated/sanity-graphql';

import { IMarketingCardGroupProps } from '../marketing-card-group/types';

export interface IMarketingTileGroupProps {
  /** The owning surface supplies card selection and state behavior. */
  CardGroupComponent: ComponentType<IMarketingCardGroupProps>;
  item: IMarketingTileGroup | IMarketingCardGroupFragment;
  props?: any;
  _marketingTileList?: Partial<BoxProps>;
  style?: BoxProps['style'];
}

export enum MarketingTileGroupType {
  MARKETING_TILE = 'MarketingTile',
  MARKETING_TILE_BASIC = 'MarketingTileBasic',
  MARKETING_TILE_PAIR = 'MarketingTilePair',
  MARKETING_TILE_QUAD = 'MarketingTileQuad',
  MARKETING_TILE_LIST = 'MarketingTileList',
}
